import React from "react"
import KEYBlue from "../common/keylist-blue"
type Props = {
  title: string
}

const NativeIosDevelopment: React.FC<Props> = ({ title }) => {
  return (
    <section className="Development-Services section-py bg-grey">
      <div className="container lg:container mx-auto">
        <div className="row grid lg:grid-cols-12  justify-start items-center">
          <div className="lg:col-span-8">
            <div className="Development-Services-head text-start mb-5">
              <h2 className="fw-700 fs-xl">{title}</h2>
            </div>
          </div>
        </div>
        <div className="row grid lg:grid-cols-12 xl:grid-cols-12 md:grid-cols-12 gy-10">
          <div className="xl:col-span-6 lg:col-span-12 md:col-span-12">
            <div className="dev-service-inner">
              <p className="fs-md text-secondary fw-400">
              Every business aims to incorporate new technical capabilities, enhance company-customer relationships, and enter new avenues with custom iOS app solutions. So, enterprises must build mobile apps on the iOS platform for a variety of devices such as iPhones, iPads, and Apple watches.
              </p>
              <p className="fs-md text-secondary mb-0 fw-400">
              Moweb is a top-notch iOS App Development Company focused on building custom iOS solutions for clients to meet their business goals. We possess in-depth expertise in cutting-edge iOS frameworks, programming languages, and stacks. To mention a few, there are Objective-C, Swift, SwiftUI, Xcode, XCTest, Cocoa Touch, and Core Data. You can outsource iOS app development to our expert iOS programmers to create native iPhone and iPad apps that are compatible with the most recent iOS version. This will make your company&apos;s digital transformation smoother.
              </p>
            </div>
          </div>
          <div className="xl:col-span-6 lg:col-span-12 md:col-span-12">
            <p className="fs-md text-secondary fw-400 mb-2.5">
            You can develop custom app solutions by leveraging the iOS development expertise we have for the following -  
            </p>
            <div className="grid md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-3 gap-5 md:gap-5 lg:gap-10">
              <div>
                <div className="gap-5 ps-0 fs-md fw-500 flex flex-col reactjs-checkboxset">
                  <KEYBlue text="Dynamic Island" />
                  <KEYBlue text="iBeacons" />
                  <KEYBlue text="NFC" />
                  <KEYBlue text="iCloud Drive" />
                  <KEYBlue text="HealthKit" />
                  <KEYBlue text="VOIP Service" />
                  <KEYBlue text="Data Protections" />
                </div>
              </div>
              <div>
                <div className="gap-5 ps-0 fs-md fw-500 flex flex-col reactjs-checkboxset">
                  <KEYBlue text="CloudKit" />
                  <KEYBlue text="WatchOS" />
                  <KEYBlue text="3D Touch" />
                  <KEYBlue text="Core Bluetooth" />
                  <KEYBlue text="In-App Purchases" />
                  <KEYBlue text="MetricKit" />
                  <KEYBlue text="Dynamic links" />

                </div>
              </div>
              <div>
                <div className="gap-5 ps-0 fs-md fw-500 flex flex-col reactjs-checkboxset">
                  <KEYBlue text="Apple Pay" />
                  <KEYBlue text="ARKit" />
                  <KEYBlue text="HomeKit" />
                  <KEYBlue text="CarPlay" />
                  <KEYBlue text="SiriKit" />
                  <KEYBlue text="Background Modes" />
                  <KEYBlue text="Social Media Integration" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default NativeIosDevelopment
